// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"9ea6beff","462":"37df5931"}[chunkId] + ".chunk.js";
};